import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/free-solid-svg-icons';
import useConversations from '../../hooks/useConversations';
import { useSocket } from '../../contexts/SocketContext';
import { useMessagesUI } from '../../contexts/MessagesUIContext';
import '../../styles/MessageDropdown.css';

const MessageDropdown = () => {
  const { connected } = useSocket();
  const { messageUnreadCount, canViewMessages } = useConversations();
  const { openMessages } = useMessagesUI();

  if (!canViewMessages) return null;

  return (
    <div className="message-dropdown">
      <button
        className={`message-icon-btn ${messageUnreadCount > 0 ? 'has-unread' : ''}`}
        onClick={() => openMessages()}
        title="Messages"
        aria-label="Messages"
        type="button"
      >
        <FontAwesomeIcon icon={faComment} />
        {messageUnreadCount > 0 && (
          <span className="message-badge">
            {messageUnreadCount > 99 ? '99+' : messageUnreadCount}
          </span>
        )}
        <span className={`message-connection ${connected ? 'connected' : 'disconnected'}`} />
      </button>
    </div>
  );
};

export default MessageDropdown;
